import React, { VFC, useState, useEffect } from 'react'
import useAnalysis from 'hooks/useAnalysis'
import { Status } from 'enums'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTwitter,
  faLine,
  faFacebook,
} from '@fortawesome/free-brands-svg-icons'

type Props = {
  className?: string
  tight?: boolean
}

const Share: VFC<Props> = (props) => {
  const [url, setUrl] = useState(
    process.env.REACT_APP_SHARE_URL || 'https://example.com'
  )
  const { status, resultIndex } = useAnalysis()

  useEffect(() => {
    if (status === Status.DONE) {
      setUrl(`${url}?result=${resultIndex}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ul className={props.className}>
      <li className="font-medium text-center font-shippori-mincho sm:text-2xl lg:text-base">
        ドレスタイプ診断をシェアする
      </li>
      <ul
        className={`mx-auto max-w-[113px] flex justify-between items-center mt-[10px] sm:max-w-[227px] sm:mt-5 lg:max-w-[164px] lg:mt-7 ${
          props.tight ? 'lg:mt-3' : ''
        }`}
      >
        <li>
          {/* TODO: Add text and hashtag */}
          <a
            className="text-[27.5px] sm:text-[55px] lg:text-[40px] text-custom-3 lg:hover:text-custom-2 lg:duration-300"
            href={`http://twitter.com/share?url=${url}`}
          >
            <FontAwesomeIcon icon={faTwitter} />
          </a>
        </li>
        <li>
          <a
            className="text-[28px] sm:text-[56px] lg:text-[40px] text-custom-3 lg:hover:text-custom-2 lg:duration-300"
            href={`https://social-plugins.line.me/lineit/share?url=${url}`}
          >
            <FontAwesomeIcon icon={faLine} />
          </a>
        </li>
        <li>
          <a
            className="text-[27.5px] sm:text-[55px] lg:text-[40px] text-custom-3 lg:hover:text-custom-2 lg:duration-300"
            href={`http://www.facebook.com/share.php?u=${url}`}
          >
            <FontAwesomeIcon icon={faFacebook} />
          </a>
        </li>
      </ul>
    </ul>
  )
}

export default Share
